const sizes = {
    navbarDesktopHeight: '5.125rem',
}

export default sizes
